import React, { useEffect } from "react";

import ScrollToTop from "react-scroll-to-top";
import RouteScrollToTop from "./Routes/RouteScrollToTop";

import AOS from "aos";
import "aos/dist/aos.css";

import "./assets/main.scss";
import "bootstrap/dist/js/bootstrap.bundle.min";

import Route from "./Routes";

function App() {
  useEffect(() => {
    AOS.init({
      offset: 0,
      easing: "ease",
      once: true,
    });
    AOS.refresh();
  }, []);
  return (
    <React.Fragment>
      <RouteScrollToTop />
      <Route />
      <ScrollToTop smooth color="#184bfa" />
    </React.Fragment>
  );
}

export default App;
